import { Modal } from "antd";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import KitsTransferForm from "../kits-transfer-form/KitsTransferForm";
import { useDispatch, useSelector } from "react-redux";
import {
  AppDispatch,
  getMyOrganization,
  getMyOrganizationRequest,
  getOrganizationList,
} from "@src/redux";

interface KitsTransformModalProps {
  modalOpen: boolean;
  setModalOpen: (open: boolean) => void;
  selectedId: any;
}

const KitsTransformModal: React.FC<KitsTransformModalProps> = ({
  modalOpen,
  setModalOpen,
  selectedId,
}) => {
  const { t } = useTranslation();

  const handleCancel = () => {
    setModalOpen(false);
  };

  

  return (
    <Modal
      title={<span className="transfer-kit-title">{t("transfer_kits")}</span>}
      open={modalOpen}
      footer={null}
      destroyOnClose
      onCancel={handleCancel}
    >
      <KitsTransferForm
        handleCancel={handleCancel}
        selectedId={selectedId}
      />
    </Modal>
  );
};

export default KitsTransformModal;
